import CompletionCalendar from './CompletionCalendar'

export default CompletionCalendar
